var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-filters text-EXPONDO-grey"},[_c('SearchFiltersHeader'),_vm._v(" "),(_vm.showSideCategories)?_c('SideCategories'):_vm._e(),_vm._v(" "),_c('SearchFiltersBody',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }